<template>
  <VDialogV3
    id="tender-bid-mismatch-dialog"
    title="Расхождения"
    position="center"
    width="600px"
    height="600px"
    hide-footer
    :loading="false"
  >
    <table>
      <thead>
      <tr>
        <th></th>
        <th>Предложено</th>
        <th>Требуется</th>
      </tr>
      </thead>
      <tbody>
      <tr
        v-for="_mismatch in mismatches"
        :key="_mismatch.label"
      >
        <td class="ellipsis"> {{ _mismatch.label }}</td>
        <td>{{ _mismatch.valueSource }}</td>
        <td>{{ _mismatch.valueTarget }}</td>
      </tr>
      </tbody>
    </table>
  </VDialogV3>
</template>

<style lang="scss" src="./TenderBidMismatchDialog.scss"/>

<script lang="ts">
import TenderBid from "@/domains/TenderBids/TenderBid";
import {MismatchItem} from "@/core/services/Mismatch";

export default defineComponent({
  name: 'TenderBidMismatchDialog',

  props: {
    tenderBid: {
      type: Object as PropType<TenderBid>,
      default: null,
    },

    /** Элемент, у которого рисуется попап. */
    target: {
      type: HTMLElement,
      default: null,
    },
  },

  computed: {
    mismatches(): MismatchItem[] {
      if (this.tenderBid) return this.tenderBid.getMismatches(this.tenderBid.tender);
      // if (this.offer) return this.offer.getMismatches(this.tender)
      // return [];
    }
  }
})
</script>
